<template>
  <div class="container">
    <loading v-model:active="loading" />
    <transition name="modal fade">
      <div class="modal-mask modal-backdrop">
        <div class="animate__fadeInDown animate__animated">
          <div class="modal-wrapper">
            <div class="modal-dialogs" role="document">
              <div class="modal-content modal-xs">
                <h1 class="tm5 modal-title d-inline-block">Change Serve</h1>
                <a
                  href="JavaScript:void(0)"
                  class="btn-cross text-right close-modal"
                  @click="hideModal($event)"
                  >&times;</a
                >

                <div class="modal-body mdScroll px-5 pb-5">
                  <div class="main-rpc-modal">
                    <RpcServer />
                    <div class="text-center w-100 attack_btn mt-3">
                      <button @click="hideModal($event)">Switch</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
  <script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "vue-loading-overlay/dist/vue-loading.css";
import RpcServer from "../RpcServer.vue";
export default {
  name: "RpcModal",
  components: {
    Loading,
    RpcServer,
  },

  props: ["error", "showModel"],
  showModal: true,
  data() {
    return {
      amount: null,
      token: false,
      loading: false,
      symbol: "WWS",
      walletBalance: null,
    };
  },
  methods: {
    hideModal(e) {
      this.$emit("w-modal-hide-click", e);
    },
  },
};
</script>
  
  <style scoped>
.progress-cont .progress__bar {
  height: 9px !important;
}
</style>
  